import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent implements OnInit {
    private router = inject(Router)

    constructor() {
        // Thin MO/SO default: buyers should be restored to /auctions/… in AppComponent.checkFromUrl before `/` activates.
        this.router.navigateByUrl('manage-saleyard-auction/home')
    }

    ngOnInit(): void {}
}
